import { Component, OnInit, AfterViewInit, Injector, Input, ElementRef, ViewChild } from '@angular/core';
import { AppComponentBase } from '../../services/AppComponentBase';


@Component({
  selector: 'app-adSpace',
  template: require('./adSpace.component.html'),
  styles: [require('./adSpace.component.scss')]
})
export class AdSpaceComponent extends AppComponentBase implements  OnInit, AfterViewInit {

  constructor(injector: Injector) {
    
    super(injector);

    //debugger;
    
      //if(this.adInformations == null)
   //    this.adInformations['728x90_socialmedia'] = {width:728, height:90, bannerSource:"SOURCE"}
      this.adInformations.push(
                            {format_zone:'728x90_socialmedia', 
                            width:728, 
                            height:90, 
                            bannerSource:"<img src='/images/test-adspaceimages/728x90_A.png'>"
                          })

     this.adInformations.push(
                            {format_zone:'728x90_tradedesk', 
                            width:728, 
                            height:90, 
                            bannerSource:"<img src='/images/test-adspaceimages/728x90_A.png'>"
                          })

      this.adInformations.push(
                            {format_zone:'728x90_landing1', 
                            width:728, 
                            height:90, 
                            bannerSource:"<img src='/images/test-adspaceimages/728x90_B.png'>"
                          })

       this.adInformations.push(
                            {format_zone:'728x90_chartmenu', 
                            width:728, 
                            height:90, 
                            bannerSource:"<img src='/images/test-adspaceimages/728x90_C.png'>"
                          })

        this.adInformations.push(
                          {format_zone:'728x90_quoteindex', 
                          width:728, 
                          height:90, 
                          bannerSource:"<img src='/images/test-adspaceimages/728x90_B.png'>"
                        })

        this.adInformations.push(
                          {format_zone:'300x250_quoteleft', 
                          width:300, 
                          height:250, 
                          bannerSource:"<img src='/images/test-adspaceimages/300x250_A.png'>"
                        })

        this.adInformations.push(
                          {format_zone:'300x250_quoteright', 
                          width:300, 
                          height:250, 
                          bannerSource:"<img src='images/test-adspaceimages/300x250_B.png'>"
                        })

         this.adInformations.push(
                          {format_zone:'336x280_quotecenter', 
                          width:336, 
                          height:280, 
                          bannerSource:"<img src='/images/test-adspaceimages/336x280_A.png'>"
                        })
                 
     this.adInformations.push(
                            {format_zone:'1083x102_landing2', 
                            width:1083, 
                            height:102, 
                            bannerSource:"<img src='/images/test-adspaceimages/1083x102_A.png'>"
                          })
    this.adInformations.push(
                            {format_zone:'728x90_orderwindow', 
                            width:728, 
                            height:90, 
                            bannerSource:"<img src='/images/test-adspaceimages/728x90_C.png'>"
                          })

    this.adInformations.push(
                            {format_zone:'724x120_landing3', 
                            width:724, 
                            height:120, 
                            bannerSource:"<img src='/images/test-adspaceimages/724x120_A.png'>"
                          })

    this.adInformations.push(
                            {format_zone:'320x50_mobile', 
                            width:320, 
                            height:50, 
                            bannerSource:"<img src='/images/test-adspaceimages/320x50.png'>"
                          })
   
   }



   public get bannerDataByZoneFormat():adInformation
   {
      let adData = this.adInformations.filter(v=>{
        return v.format_zone == this.selectedFormat + "_" + this.selectedZone
      })

      if(adData.length>0)
      {
         return adData[0];
      }
      
      return {format_zone:'any', width:0, height:0, bannerSource:''}
   }


   public get bannerSource()
   {
     return this.bannerDataByZoneFormat.bannerSource
   }

  @ViewChild('adContainer') adContainer!: ElementRef;
  @ViewChild('adContent') adContent!: ElementRef;

  @Input() public set selectedZone(value: string) {

   this._selectedZone = value;

  }
  public _selectedZone:string= "";

  public get selectedZone()
  {
    return this._selectedZone;
  }


  @Input() public set selectedFormat(value: string) {

    this._selectedFormat = value;
 
   }
   public _selectedFormat:string= "";
 
   public get selectedFormat()
   {
     return this._selectedFormat;
   }

   @Input() public set adEnabled(value: boolean) {

    this._adEnabled = value;
 
   }
   public _adEnabled:boolean = true;
 
   public get adEnabled()
   {
     return this._adEnabled;
   }

   @Input() public set marginTop(value: number) {

    this._marginTop = value;
 
   }
   public _marginTop:number = 0;
 
   public get marginTop()
   {
     return this._marginTop;
   }


  ngOnInit() {
  }

  ngAfterViewInit()
  {
   
    
  }

  public get adSpaceEnabled():boolean
  {
    return this.dataService.EnableAdSpace
  }

  
  private _updateContainerHeight: number = 0;
  public get updateContainerHeight (): number {
    return this._updateContainerHeight;
  }
  public set updateContainerHeight ( value: number ) {
    this._updateContainerHeight = value;
  }
  //}
 

//  [ngStyle]="calculateScale()"
  public calculateScale() {
    let w = this.panelWidth;
    let unit = this.bannerDataByZoneFormat.width;

    if(w>this.bannerDataByZoneFormat.width)
    {
      this.updateContainerHeight =  this.bannerDataByZoneFormat.height;
      return {
        transform: "scale(1)"
    };
    }

    
     


    let scale = w / unit;
    if( w>0 )
    {
      this.updateContainerHeight = scale*this.bannerDataByZoneFormat.height;
     // debugger;
    }

    return {
        transform: "scale(" + scale + ")"
    };
  }

  get panelWidth() {
    if(this.adContainer)
    {
      return this.adContainer.nativeElement.offsetWidth
    }
    else
    {
      return 0;
    }
}

public adInformations:adInformation[] = [];
//adInformations['728x90_socialmedia'] = {width:728, height:90, bannerSource:"SOURCE"}

}

export interface adInformation
{
  format_zone:string;
  width:number;
  height:number;
  bannerSource:string;
}